module.exports = __webpack_public_path__ + "img/product_123.648575b.webp";